export const ORDER_ITEMS_GRID_CODE = 'service-case-order-items';
